import UserLoginLog from './index';

export default { path: '/home/userLoginLog', component: UserLoginLog };
